import { EstateType } from '/@/modules/estate/enums/EstateType';
import Lang from '/@/modules/core/app/services/Lang';
import Enum from '/@/modules/core/app/helpers/Enum';
import EstateTypeLang from '/@/modules/estate/services/EstateTypeLang';

export class ResidenceType extends Enum {
  static PRIMARY = {
    key: 'primary',
    get value() {
      return Lang.t('asset.primary-residence');
    },
    get description() {
      return EstateTypeLang.realEstatePrimaryResidenceDescription;
    }
  };

  static SECONDARY = {
    key: 'secondary',
    get value() {
      return Lang.t('asset.secondary-residence');
    },
    get description() {
      return Lang.t('asset.vacation-home-part');
    }
  };

  static RESIDENTIAL_INVESTMENT = {
    key: 'investment',
    get value() {
      return Lang.t('asset.residential-real-estate');
    },
    get description() {
      return Lang.t('asset.generates-or-purposes');
    }
  };

  static COMMERCIAL_INVESTMENT = {
    key: 'commercial_investment',
    get value() {
      return Lang.t('asset.commercial-investment-estate');
    },
    get description() {
      return Lang.t('asset.intended-commercial-purposes');
    }
  };

  static getResidenceTypesByEstate(estateType) {
    switch (estateType) {
      case EstateType.CLEAR_WILL.key:
      case EstateType.CLEAR_VAULT.key:
        return [
          this.PRIMARY,
          this.SECONDARY,
          {
            ...this.RESIDENTIAL_INVESTMENT,
            get value() {
              return Lang.t('asset.investment-real-estate');
            }
          }
        ];
      case EstateType.CLEAR_ESTATE.key:
      default:
        return this.getValues();
    }
  }
}
